<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">
            <app-filtros-reportes #ctrl [datos]="datos" [cargando]="cargando" ruta="inventario/escaso"></app-filtros-reportes>

            <div style="overflow:auto;" [style.height.px]="ctrl.tamano-160">
                <div id="imprimir">
                    <!--Tabla -->
                    <table id class="table is-striped  is-fullwidth" *ngIf="!cargando ">
                        <thead>
                            <tr>
                                <th>Clave</th>
                                <th>Código barras</th>
                                <th>Nombre</th>
                                <th>Categoría</th>
                                <th>Existencia</th>
                                <th>Minimo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of ctrl.datos; let i=index">
                                <th>{{ item.clave }}</th>
                                <td>
                                    <strong>{{item.codigo_barras}} </strong>
                                </td>
                                <td>{{ item.nombre }} </td>
                                <td>{{ item.categorias.nombre }}</td>
                                <td>{{ item.existencia }}</td>
                                <td>{{ item.minimo }}</td>
                            </tr>
                            <tr *ngIf="ctrl.datos.length == 0">
                                <td colspan="5" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                            </tr>
                        </tbody>

                    </table>
                </div>
            </div>
        </div>
    </div>
</div>